/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Fedorov Maxim
 * @author Evgenij Tyan
 * @version 1.0.1
 * @since 1.0.1
 */

import { createAction } from '../../../../../modules/app/createAction';
import {
    CLEAN_LIST_PAYMENT_HISTORY,
    LOAD_LIST_PAYMENT_HISTORY_FAIL,
    LOAD_LIST_PAYMENT_HISTORY_REQUEST,
    LOAD_LIST_PAYMENT_HISTORY_SUCCESS,
} from './widgetPaymentHistoryConstants';
import {
    IPaymentsHistoryItem,
    TCleanPaymentHistoryListAction,
    TLoadListPaymentHistoryFailAction,
    TLoadListPaymentHistoryRequestAction,
    TLoadListPaymentHistorySuccessAction,
} from './widgetPaymentHistoryTypes';

/*
* -------------------------------------------
*        LOAD HISTORY PAYMENTS
* -------------------------------------------
*/

export const widgetPaymentHistoryRequest = (): TLoadListPaymentHistoryRequestAction =>
    createAction(LOAD_LIST_PAYMENT_HISTORY_REQUEST);

export const widgetPaymentHistorySuccess = (payload: IPaymentsHistoryItem[]): TLoadListPaymentHistorySuccessAction =>
    createAction(LOAD_LIST_PAYMENT_HISTORY_SUCCESS, payload);

export const widgetPaymentHistoryFail = (payload: string): TLoadListPaymentHistoryFailAction =>
    createAction(LOAD_LIST_PAYMENT_HISTORY_FAIL, payload);

export const cleanListPaymentHistory = (): TCleanPaymentHistoryListAction =>
    createAction(CLEAN_LIST_PAYMENT_HISTORY);
